// BAG CRAP: "Notify me" for sold-out items (Klaviyo)
// 1. Signs the shopper up for Klaviyo Back in Stock on that exact listing (fires if it's restocked).
// 2. Records a "Requested Sold-Out Item" event with the item's collections, so themed
//    segments ("Asked for: Muppets", etc.) can be emailed when a similar new piece is listed.
(function () {
const KLAVIYO_COMPANY_ID = "XRLAjE";
const REQUEST_METRIC = "Requested Sold-Out Item";
const NOTIFY_CARD_LABEL = "Notify me";
const NOTIFY_PDP_LABEL = "Notify me when it's back";

const parseList = (s) => { try { const v = JSON.parse(s || "[]"); return Array.isArray(v) ? v : []; } catch (e) { return []; } };

const buildNotifyPanel = () => {
  let panel = document.getElementById("notify-panel");
  if (panel) return panel;

  const style = document.createElement("style");
  style.textContent = `
    #notify-panel{position:fixed;inset:0;z-index:99999;display:none;align-items:flex-end;justify-content:center;background:rgba(0,0,0,.45)}
    #notify-panel.open{display:flex}
    #notify-panel .np-box{background:#fff;width:100%;max-width:440px;padding:22px 20px 26px;box-sizing:border-box;position:relative}
    @media (min-width:768px){#notify-panel{align-items:center}}
    #notify-panel .np-close{position:absolute;top:10px;right:14px;font-size:22px;line-height:1;color:#222;background:none;border:0;cursor:pointer;padding:6px}
    #notify-panel .np-item{display:flex;gap:14px;align-items:center;margin:4px 0 18px}
    #notify-panel .np-item img{width:84px;height:84px;object-fit:cover;flex:0 0 84px;background:#f4f4f4}
    #notify-panel .np-title{font-size:14px;line-height:1.3;text-transform:uppercase;margin:0 0 4px}
    #notify-panel .np-variant{font-size:13px;color:#6b6762;margin:0}
    #notify-panel .np-heading{font-size:16px;text-transform:uppercase;margin:0 0 6px}
    #notify-panel .np-text{font-size:14px;color:#3a3734;margin:0 0 14px;line-height:1.4}
    #notify-panel input[type=email]{width:100%;box-sizing:border-box;border:1px solid #e1e1e1;padding:15px 14px;font-size:16px;margin:0 0 10px;border-radius:0;-webkit-appearance:none}
    #notify-panel .np-submit{width:100%;border:0;background:#4D04AD;color:#fff;padding:17px 10px;font-size:14px;letter-spacing:1px;text-transform:uppercase;text-align:center;cursor:pointer}
    #notify-panel .np-submit[disabled]{opacity:.6}
    #notify-panel .np-msg{font-size:14px;margin:12px 0 0;min-height:1em}
    #notify-panel .np-msg.error{color:#c0262d}
    #notify-panel .np-msg.success{color:#4D04AD}
  `;
  document.head.appendChild(style);

  panel = document.createElement("div");
  panel.id = "notify-panel";
  panel.innerHTML = `
    <div class="np-box" role="dialog" aria-modal="true" aria-labelledby="np-heading">
      <button type="button" class="np-close" aria-label="Close">&times;</button>
      <p class="np-heading heading" id="np-heading">This one's sold</p>
      <p class="np-text">Leave your email and we'll let you know if it comes back, or when we find another like it.</p>
      <div class="np-item">
        <img alt="">
        <div>
          <p class="np-title heading"></p>
          <p class="np-variant"></p>
        </div>
      </div>
      <form class="np-form" novalidate>
        <input type="email" name="email" placeholder="Email address" autocomplete="email" required>
        <button type="submit" class="np-submit heading">Notify me</button>
      </form>
      <p class="np-msg" aria-live="polite"></p>
    </div>
  `;
  document.body.appendChild(panel);

  const close = () => panel.classList.remove("open");
  panel.addEventListener("click", (e) => { if (e.target === panel) close(); });
  panel.querySelector(".np-close").addEventListener("click", close);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });

  panel.querySelector(".np-form").addEventListener("submit", async (e) => {
    e.preventDefault();
    const emailInput = panel.querySelector("input[type=email]");
    const msg = panel.querySelector(".np-msg");
    const submit = panel.querySelector(".np-submit");
    const email = emailInput.value.trim();

    msg.className = "np-msg";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = "Please enter a valid email address.";
      msg.classList.add("error");
      emailInput.focus();
      return;
    }

    submit.disabled = true;
    msg.textContent = "";
    const d = panel.dataset;
    const headers = { "Content-Type": "application/json", "revision": "2024-06-15" };

    // Back in Stock on this exact listing
    const bis = fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: { data: { type: "profile", attributes: { email } } },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: { data: { type: "catalog-variant", id: `$shopify:::$default:::${d.variantId}` } },
          },
        },
      }),
    }).then((r) => r.ok).catch(() => false);

    // Request record with the item's collections (for themed segments)
    const request = fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        data: {
          type: "event",
          attributes: {
            properties: {
              ProductName: d.title || "",
              VariantName: d.variantTitle || "",
              VariantID: d.variantId || "",
              ProductHandle: d.handle || "",
              URL: d.handle ? `${location.origin}/products/${d.handle}` : location.href,
              ImageURL: d.img ? (d.img.indexOf("//") === 0 ? "https:" + d.img : d.img) : "",
              Collections: parseList(d.collections),
              CollectionNames: parseList(d.collectionNames),
              Page: location.pathname,
            },
            metric: { data: { type: "metric", attributes: { name: REQUEST_METRIC } } },
            profile: { data: { type: "profile", attributes: { email } } },
          },
        },
      }),
    }).then((r) => r.ok).catch(() => false);

    const [bisOk, requestOk] = await Promise.all([bis, request]);
    submit.disabled = false;
    if (bisOk || requestOk) {
      msg.textContent = "You're on the list. We'll email you if it comes back or we find another like it.";
      msg.classList.add("success");
      panel.querySelector(".np-form").style.display = "none";
    } else {
      msg.textContent = "Something went wrong. Please try again.";
      msg.classList.add("error");
    }
  });

  return panel;
};

const openNotify = window.bcOpenNotify = ({ variantId, title, variantTitle, img, handle, collections, collectionNames }) => {
  if (!variantId) return;
  const panel = buildNotifyPanel();
  const d = panel.dataset;
  d.variantId = variantId;
  d.title = title || "";
  d.variantTitle = variantTitle && variantTitle !== "Default Title" ? variantTitle : "";
  d.img = img || "";
  d.handle = handle || "";
  d.collections = collections || "[]";
  d.collectionNames = collectionNames || "[]";
  panel.querySelector(".np-title").textContent = d.title;
  panel.querySelector(".np-variant").textContent = d.variantTitle;
  const image = panel.querySelector(".np-item img");
  if (img) { image.src = img; image.style.display = ""; } else { image.style.display = "none"; }
  panel.querySelector(".np-form").style.display = "";
  const msg = panel.querySelector(".np-msg");
  msg.textContent = "";
  msg.className = "np-msg";
  panel.classList.add("open");
  const input = panel.querySelector("input[type=email]");
  setTimeout(() => input.focus(), 50);
};

// Item details from a product card (collection pages, homepage)
const cardInfo = (card) => {
  const titleLink = card.querySelector("a.title");
  return {
    title: titleLink ? titleLink.textContent.trim() : "",
    handle: card.dataset.handle || "",
    collections: card.dataset.collections || "[]",
    collectionNames: card.dataset.collectionNames || "[]",
  };
};

// Item details on a product page (set in layout/theme.liquid)
const pageInfo = () => {
  const p = window.bcProduct || {};
  return {
    handle: p.handle || "",
    collections: JSON.stringify(p.collections || []),
    collectionNames: JSON.stringify(p.collectionNames || []),
  };
};

// Collection & homepage cards: show "Notify me" when a sold-out option is chosen
document.addEventListener("change", (event) => {
  const select = event.target.closest(".product-form .variant-select");
  if (!select) return;
  const card = select.closest(".product");
  const button = card ? card.querySelector(".plp-atc-btn") : null;
  if (!button) return;
  const option = select.selectedOptions[0];
  if (option && parseInt(option.dataset.stock) === 0) {
    button.innerHTML = `<span style="font-size:11px;letter-spacing:1px;white-space:nowrap;color:#DD24D0;opacity:1;animation:none;">${NOTIFY_CARD_LABEL}</span>`;
    button.dataset.iconHtml = "<span>\u{1F6D2}</span>";
  }
});

// Collection & homepage cards: tapping "Notify me" on a sold-out option opens the sign-up panel
document.addEventListener("click", (event) => {
  const button = event.target.closest(".plp-atc-btn");
  if (!button || !button.dataset.atcId || parseInt(button.dataset.stock) !== 0) return;
  const card = button.closest(".product");
  const select = card ? card.querySelector(".product-form .variant-select") : null;
  if (!select) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const option = select.selectedOptions[0];
  openNotify(Object.assign(cardInfo(card), {
    variantId: button.dataset.atcId,
    variantTitle: option ? option.dataset.title : "",
    img: option ? option.dataset.img : "",
  }));
}, true);

// Collection & homepage cards: sold-out one-of-a-kind items ("Notify me") open the same panel
// (replaces the old "Source a product" form for cards)
document.addEventListener("click", (event) => {
  const button = event.target.closest(".loop .product .source-btn");
  if (!button) return;
  const card = button.closest(".product");
  event.preventDefault();
  event.stopImmediatePropagation();
  openNotify(Object.assign(cardInfo(card), {
    variantId: button.dataset.variantId,
    title: button.dataset.title || cardInfo(card).title,
    variantTitle: "",
    img: button.dataset.img || "",
  }));
}, true);

// Product pages: relabel when a sold-out option is chosen
document.addEventListener("change", (event) => {
  const select = event.target.closest(".product-atc .variant-select");
  if (!select) return;
  const option = select.selectedOptions[0];
  const button = select.closest("form").querySelector(".pdp-atc-btn");
  if (option && button && parseInt(option.dataset.inventory) === 0) {
    button.innerHTML = NOTIFY_PDP_LABEL;
  }
});

// Product pages: sold-out button becomes "Notify me when it's back"
const relabelSoldOutButtons = () => {
  document.querySelectorAll(".product-atc .pdp-atc-btn, .product-atc .single-pdp-atc-btn").forEach((btn) => {
    if (btn.innerText.trim().toLowerCase() === "sold out") {
      btn.innerHTML = NOTIFY_PDP_LABEL;
    }
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", relabelSoldOutButtons);
} else {
  relabelSoldOutButtons();
}

document.addEventListener("click", (event) => {
  const btn = event.target.closest(".product-atc .pdp-atc-btn, .product-atc .single-pdp-atc-btn");
  if (!btn) return;

  const productTitle = (document.querySelector(".information h1") || {}).textContent || "";

  if (btn.classList.contains("single-pdp-atc-btn")) {
    event.preventDefault();
    openNotify(Object.assign(pageInfo(), {
      variantId: btn.dataset.variantId,
      title: productTitle.trim(),
      variantTitle: "",
      img: btn.dataset.img,
    }));
    return;
  }

  if (btn.getAttribute("type") === "source") {
    const select = btn.closest("form").querySelector(".variant-select");
    const option = select ? select.selectedOptions[0] : null;
    if (!option || option.disabled) return;
    event.preventDefault();
    openNotify(Object.assign(pageInfo(), {
      variantId: option.value,
      title: productTitle.trim(),
      variantTitle: option.dataset.title,
      img: option.dataset.img,
    }));
  }
});
})();
